(() => {
  const key = 'verde:navigation:182511010171:v1';
  const pendingKey = key + ':pending';
  const maxAge = 30 * 60 * 1000;
  const safeUrl = (value) => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      ['preview_theme_id', '_fd', 'pb'].forEach((param) => url.searchParams.delete(param));
      return url;
    } catch {
      return null;
    }
  };
  const pageId = (url) => {
    const product = url.pathname.match(/\/products\/([^/]+)/);
    return product ? '/products/' + product[1] : url.pathname + url.search;
  };
  const read = (storageKey) => {
    try {
      return JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    } catch {
      return null;
    }
  };
  const write = (storageKey, value) => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(value));
    } catch {}
  };
  const current = safeUrl(location.href);
  if (!current) return;
  const stored = read(key);
  const pending = read(pendingKey);
  const referrer = document.referrer ? safeUrl(document.referrer) : null;
  const navigation = performance.getEntriesByType('navigation')[0]?.type;
  let previous = null;
  if (pending && Date.now() - pending.time < maxAge) {
    const target = safeUrl(pending.target);
    if (target && pageId(target) === pageId(current)) previous = pending.source;
  }
  if (!previous && stored && Date.now() - stored.time < maxAge) {
    const last = safeUrl(stored.current?.url);
    if (last && pageId(last) === pageId(current) && navigation === 'reload') {
      previous = stored.previous;
    } else if (last && referrer && pageId(last) === pageId(referrer)) {
      previous = stored.current;
    }
  }
  if (!previous && referrer) previous = { url: referrer.href, title: '' };
  const previousUrl = previous && safeUrl(previous.url);
  if (!previousUrl || pageId(previousUrl) === pageId(current)) previous = null;
  else previous = { url: previousUrl.pathname + previousUrl.search + previousUrl.hash, title: String(previous.title || '') };
  try { sessionStorage.removeItem(pendingKey); } catch {}
  const page = () => ({
    url: location.pathname + location.search + location.hash,
    title: (document.querySelector('main h1')?.textContent || document.title).trim()
  });
  const render = () => {
    if (!previous) return;
    document.querySelectorAll('[data-verde-product-breadcrumb]').forEach((nav) => {
      const item = nav.querySelector('[data-verde-previous-item]');
      const link = nav.querySelector('[data-verde-previous-link]');
      if (!item || !link) return;
      const home = safeUrl(nav.querySelector('a')?.href);
      const destination = safeUrl(previous.url);
      if (home && destination && pageId(home) === pageId(destination)) {
        item.hidden = true;
        return;
      }
      link.href = previous.url;
      link.textContent = previous.title || link.dataset.previousLabel;
      item.hidden = false;
    });
  };
  const save = () => write(key, { current: page(), previous, time: Date.now() });
  render();
  save();
  window.addEventListener('pageshow', () => { render(); save(); });
  document.addEventListener('shopify:section:load', render);
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download')) return;
    const destination = safeUrl(link.href);
    const source = page();
    const sourceUrl = safeUrl(source.url);
    if (!destination || !sourceUrl || pageId(destination) === pageId(sourceUrl)) return;
    write(pendingKey, { target: destination.href, source, time: Date.now() });
  }, true);
})();
